import firebase from 'firebase/compat/app';
import STORE_CONSTANTS from '../constants';
import withoutNulls from '../../api/search/withoutNulls';
import {
  migrateScorecardIsV3Published,
  migrateScorecardV3Access,
} from '../../screens/Settings/Advanced/V3Migrators/ContentV3AccessMigrator/utils';

export const SCORECARDS_DOC = 'scorecards';
export const CURRENT_SCORECARDS_VERSION = 'v3';

export const scorecardsConverter = {
  toFirestore(
    scorecard: Scorecards.Scorecard,
  ): firebase.firestore.DocumentData {
    return withoutNulls({ ...scorecard });
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<Scorecards.Scorecard>,
    options: firebase.firestore.SnapshotOptions,
  ): Scorecards.Scorecard {
    const data = snapshot.data(options);

    const scorecard: Scorecards.Scorecard = {
      ...data,
      access: data.access
        ? data.access
        : {
            type: 'Users',
            version: '2',
            userIds: data.assigneeId,
          },
      isV3Published:
        data.isV3Published !== undefined
          ? data.isV3Published
          : migrateScorecardIsV3Published(data),
      v3Access: (data.v3Access = data.v3Access
        ? data.v3Access
        : migrateScorecardV3Access(data)),
      labelIds: data.labelIds || [],
    };

    return scorecard;
  },
};

const getScorecardsRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.VISUALISATIONS_COLLECTION)
    .doc(SCORECARDS_DOC)
    .collection(CURRENT_SCORECARDS_VERSION)
    .withConverter(scorecardsConverter);
};

export default getScorecardsRef;
